import type { ScannerConfig } from "../interfaces/types";

export const SCANNER_ASSET_BASE = `${import.meta.env.BASE_URL}scanner`;

const CONFIG: ScannerConfig = {
  guideAspectRatio: 1.585, // ID-1 (85.6mm x 54mm)
  analysisFps: 6,
  // Require a longer streak of good frames so the shot is captured while steady.
  stableFramesToGreen: 10,
  quality: {
    // Higher bar for OCR-grade captures: sharper, bigger, better-aligned,
    // well-exposed and with less glare on the document.
    sharpnessMinVariance: 130,
    brightnessMin: 70,
    brightnessMax: 190,
    glareMaxRatio: 0.03,
    minDetectAreaRatio: 0.15,
    minQuadAreaRatio: 0.25,
    aspectRatioTolerance: 0.32,
  },
  ocr: {
    frontMinConfidence: 70,
    frontAnchors: [
      "REPUBLICA", "ARGENTINA", "APELLIDO", "NOMBRE", "SEXO",
      "NACIONALIDAD", "DOCUMENTO", "EJEMPLAR", "DNI", "FECHA",
    ],
    documentNumberRegex: "\\b\\d{7,8}\\b",
  },
};

export default CONFIG;
